module.exports = "/images/user.svg?f5baf79dc2c0c3be4198edee98486e51";